import axios, { ApiResponse, getRequestError } from "../../utils/axios";
import { UploadFileErrors } from "./file.error";

export type UploadFileRequest = { file: File; width?: number; height?: number };
export type UploadFileResponse = { file_id: string; file_link: string };
export type getFileLinkRequest = { file_id: string };
export type getFileLinkResponse = { file_link: string };

export const uploadFile = (
  request: UploadFileRequest
): ApiResponse<UploadFileResponse, UploadFileErrors> => {
  const formData = new FormData();
  formData.append("file", request.file);
  if (request.width) {
    formData.append("width", request.width.toString());
  }
  if (request.height) {
    formData.append("height", request.height.toString());
  }
  return axios
    .post<UploadFileResponse>("/UploadFile", formData)
    .then((res) => ({
      response: res.data,
    }))
    .catch((error) => {
      return { error: getRequestError<UploadFileErrors>(error) };
    });
};

export const getFileLink = (
  request: getFileLinkRequest
): ApiResponse<getFileLinkResponse, UploadFileErrors> => {
  const formData = new FormData();
  formData.append("file_id", request.file_id);
  return axios
    .post<getFileLinkResponse>("/GetLink", { file_id: request.file_id })
    .then((res) => ({ response: res.data }))
    .catch((error) => ({ error: getRequestError<UploadFileErrors>(error) }));
};
